export const PROCESSING_RESULT_EDITOR_REGEN_FINISHED_EVENT = "processing-result:editor-regeneration-finished";
export const PROCESSING_RESULT_EDITOR_REGEN_ERROR_EVENT = "processing-result:editor-regeneration-error";

export function dispatchCancelableProcessingResultEditorEvent(name, detail = {}) {
  return window.dispatchEvent(
    new CustomEvent(name, {
      cancelable: true,
      detail,
    })
  );
}